import { useEffect, useState } from "react";
import { Subscription } from "rxjs";
import { services } from "../../../types/services";

export default function BetfairOddsDisplay(): React.JSX.Element {
  const [odds, setOdds] = useState<Map<string, number>>(new Map());

  useEffect(() => {
    const subscriptions: Subscription[] = [
      services.customPriceGenerationService.currentPriceSubject.subscribe(
        (currentPrice: Map<string, number>) => {
          setOdds(currentPrice);
        }
      ),
    ];

    return () =>
      subscriptions.forEach((subscription) => subscription.unsubscribe());
  }, []);

  return (
    <div className="betfair-display">
      <div className="separator-title">Odds</div>
      {odds && <div>{odds}</div>}
    </div>
  );
}
